export function abortable<T>(operation: Promise<T>, signal: AbortSignal, milliseconds = 10000): Promise<T> {
  return new Promise((resolve, reject) => {
    const cleanup = () => { clearTimeout(timer); signal.removeEventListener("abort", cancel); };
    const cancel = () => { cleanup(); reject(new DOMException("Captura cancelada", "AbortError")); };
    const timer = setTimeout(() => { cleanup(); reject(new Error("audio-timeout")); }, milliseconds);
    signal.addEventListener("abort", cancel, { once: true });
    operation.then(value => { cleanup(); resolve(value); }, error => { cleanup(); reject(error); });
    if (signal.aborted) cancel();
  });
}

export async function createDenoiser(context: AudioContext, failed: () => void, signal: AbortSignal) {
  if (context.sampleRate !== 48000) throw new Error("unsupported-audio-rate");
  const url = typeof __ECLETICA_DENOISE_URL__ === "undefined" ? "/audio-denoise.js" : __ECLETICA_DENOISE_URL__;
  await abortable(context.audioWorklet.addModule(url), signal);
  signal.throwIfAborted();
  const node = new AudioWorkletNode(context, "ecletica-voice-denoise", { numberOfInputs: 1, numberOfOutputs: 1, outputChannelCount: [1], channelCount: 1, channelCountMode: "explicit" });
  let closed = false, ready = false;
  const close = () => {
    if (closed) return;
    closed = true; node.onprocessorerror = null; node.port.onmessage = null;
    node.port.postMessage("close"); node.port.close(); node.disconnect();
  };
  const starting = new Promise<void>((resolve, reject) => {
    node.port.onmessage = event => {
      if (event.data === "ready") { ready = true; resolve(); }
      if (event.data === "failed") { if (ready) failed(); else reject(new Error("audio-init-failed")); }
    };
    node.onprocessorerror = () => { if (ready) failed(); else reject(new Error("audio-init-failed")); };
  });
  try { await abortable(starting, signal); return { node, close }; }
  catch (error) { close(); throw error; }
}
declare const __ECLETICA_DENOISE_URL__: string;

